<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body{background: #f7faff; font-size: 14px}
  body,ul,ul li{ margin: 0; padding: 0; color: #34495e; list-style: none}
  input{outline:none;}
  input::-webkit-input-placeholder,button::-webkit-input-placeholder {
    color: #9aabb8;
  }
  .main{ width: 1200px; margin: 0 auto}
  .div_table{ display: table}
  .div_table>div{display: table-row}
  .div_table>div>div{display: table-cell}
  .page{ text-align: right; padding: 15px 0}
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{ background: #fff;margin-right: 0}
  .el-pagination{ padding: 0}
</style>



// WEBPACK FOOTER //
// src/App.vue